module.exports = __webpack_public_path__ + "img/stromae.b87ff026.jpg";